import { getBookingFlowAnalyticsCollectorUrl } from "../firebase/runtimeEndpoints.ts";
import { createReliableAnalyticsDelivery } from "./analyticsReliableDelivery.ts";
import type { BookingFlowAnalyticsWriter } from "./bookingFlowAnalyticsEmitter.ts";

export const createBookingFlowAnalyticsPublicCollectorWriter = (
  collectorUrl = getBookingFlowAnalyticsCollectorUrl(),
  fetchImpl: typeof fetch = fetch,
): BookingFlowAnalyticsWriter => {
  const delivery = createReliableAnalyticsDelivery({
    collectorUrl,
    fetchImpl,
    storageKey: "mintleaf:analytics:booking-flow:outbox:v1",
  });
  return event => delivery.enqueue(event.eventId, { event });
};
